import { render, staticRenderFns } from "./TabsContent1.vue?vue&type=template&id=9b5f4608&scoped=true"
import script from "./TabsContent1.vue?vue&type=script&lang=js"
export * from "./TabsContent1.vue?vue&type=script&lang=js"
import style0 from "./TabsContent1.vue?vue&type=style&index=0&id=9b5f4608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5f4608",
  null
  
)

export default component.exports